var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessories(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8583 29.4375L27.0054 38.8283V25.4951",
    stroke: "#1ACDA7",
    strokeWidth: 4,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8573 29.4374C11.787 30.9556 9.70803 31.3474 8.15801 30.3189C7.12466 29.6333 5.95599 28.8619 4.99645 28.213C3.69246 27.3437 2.90515 25.8868 2.90515 24.3318V18.8345C2.90515 14.5983 4.6028 10.5212 7.61673 7.52153C10.6307 4.52188 14.7148 2.83228 18.9836 2.83228H24.3471C34.7052 2.83228 43.095 11.1823 43.095 21.4914H34.8159C34.1024 21.4914 33.4258 21.773 32.9215 22.2749C32.1957 22.9973 31.0762 24.1115 30.1413 25.042C29.1571 26.0214 27.5579 26.0214 26.5615 25.042C25.0114 23.5115 22.8586 22.7279 20.6689 22.9238C18.4915 23.1075 16.4986 24.2584 15.2438 26.0459C13.9275 27.9192 12.8573 29.4374 12.8573 29.4374Z",
    stroke: "#1ACDA7",
    strokeWidth: 4,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0044 38.8286L29.6862 42.8322",
    stroke: "#1ACDA7",
    strokeWidth: 4,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6345 2.89795V5.50581",
    stroke: "#1ACDA7",
    strokeWidth: 4,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.994 2.84497V5.51405",
    stroke: "#1ACDA7",
    strokeWidth: 4,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3412 3.27661V5.51717",
    stroke: "#1ACDA7",
    strokeWidth: 4,
    strokeMiterlimit: 13.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessories);
export default __webpack_public_path__ + "static/media/accessories.293354cc6fd6bcb3b3ead92c8ad2c362.svg";
export { ForwardRef as ReactComponent };